import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const DriverForm = ({ driver, onSave, onCancel, loading, transporterId, vehicles }) => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [licenseNo, setLicenseNo] = useState('');
    const [vehicleId, setVehicleId] = useState('');
    const [licenseDoc, setLicenseDoc] = useState(null);
    const [idProofDoc, setIdProofDoc] = useState(null);
    const [existingLicenseDocUrl, setExistingLicenseDocUrl] = useState(null);
    const [existingIdProofDocUrl, setExistingIdProofDocUrl] = useState(null);
    const [
        // showLicenseDocUpload, 
        setShowLicenseDocUpload
    ] = useState(true);
    const [
        // showIdProofDocUpload, 
        setShowIdProofDocUpload
    ] = useState(true);
    const [isActive, setIsActive] = useState(true);
    const [deleteLicenseDoc, setDeleteLicenseDoc] = useState(false);
    const [deleteIdProofDoc, setDeleteIdProofDoc] = useState(false);

    useEffect(() => {
        if (driver) {
            setName(driver.name || '');
            setPhone(driver.phone || '');
            setLicenseNo(driver.licenseNo || '');
            setVehicleId(driver.vehicleId || '');
            setIsActive(driver.isActive);
            setExistingLicenseDocUrl(driver.licenseDocUrl || null);
            setShowLicenseDocUpload(!driver.licenseDocUrl);
            setExistingIdProofDocUrl(driver.idProofDocUrl || null);
            setShowIdProofDocUpload(!driver.idProofDocUrl);
        } else {
            setName('');
            setPhone('');
            setLicenseNo('');
            setVehicleId('');
            setIsActive(true);
            setExistingLicenseDocUrl(null);
            setShowLicenseDocUpload(true);
            setExistingIdProofDocUrl(null);
            setShowIdProofDocUpload(true);
        }
    }, [driver]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('transporterId', transporterId);
        formData.append('name', name);
        formData.append('phone', phone);
        formData.append('licenseNo', licenseNo);
        if (vehicleId) formData.append('vehicleId', vehicleId);

        // Handle License Document
        if (licenseDoc) {
            formData.append('licenseDoc', licenseDoc);
        } else if (existingLicenseDocUrl && !deleteLicenseDoc) {
            formData.append('licenseDocUrl', existingLicenseDocUrl);
        } else if (deleteLicenseDoc) {
            formData.append('deleteLicenseDoc', 'true');
        }

        // Handle ID Proof Document
        if (idProofDoc) {
            formData.append('idProofDoc', idProofDoc);
        } else if (existingIdProofDocUrl && !deleteIdProofDoc) {
            formData.append('idProofDocUrl', existingIdProofDocUrl);
        } else if (deleteIdProofDoc) {
            formData.append('deleteIdProofDoc', 'true');
        }

        formData.append('isActive', isActive);
        if (driver) formData.append('_id', driver._id);

        onSave(formData);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>License No</Form.Label>
                <Form.Control type="text" value={licenseNo} onChange={(e) => setLicenseNo(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Assign Vehicle (Optional)</Form.Label>
                <Form.Select value={vehicleId} onChange={(e) => setVehicleId(e.target.value)}>
                    <option value="">-- Select Vehicle --</option>
                    {vehicles.map(v => <option key={v._id} value={v._id}>{v.vehicleNumber}</option>)}
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>License Document</Form.Label>
                {existingLicenseDocUrl && !deleteLicenseDoc ? (
                    <div className="d-flex align-items-center">
                        <a href={existingLicenseDocUrl} target="_blank" rel="noopener noreferrer" className="me-2">View Document</a>
                        <Button variant="info" size="sm" onClick={() => { setDeleteLicenseDoc(true); setLicenseDoc(null); setShowLicenseDocUpload(true); }} className="me-2">Change</Button>
                    </div>
                ) : (
                    <Form.Control type="file" onChange={(e) => { setLicenseDoc(e.target.files[0]); setDeleteLicenseDoc(false); }} />
                )}
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>ID Proof Document</Form.Label>
                {existingIdProofDocUrl && !deleteIdProofDoc ? (
                    <div className="d-flex align-items-center">
                        <a href={existingIdProofDocUrl} target="_blank" rel="noopener noreferrer" className="me-2">View Document</a>
                        <Button variant="info" size="sm" onClick={() => { setDeleteIdProofDoc(true); setIdProofDoc(null); setShowIdProofDocUpload(true); }} className="me-2">Change</Button>
                    </div>
                ) : (
                    <Form.Control type="file" onChange={(e) => { setIdProofDoc(e.target.files[0]); setDeleteIdProofDoc(false); }} />
                )}
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check type="checkbox" label="Is Active" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            </Form.Group>
            <Button variant="secondary" onClick={onCancel} disabled={loading} className="me-2">Cancel</Button>
            <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
            </Button>
        </Form>
    );
};

export default DriverForm;
